function isVideo(fileType: string) {
    return fileType === "mp4";
}
export default isVideo;